
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Block, ButtonTarget, ButtonTheme, ButtonVariant } from "../types";

interface ButtonBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
}

export const ButtonBlock = ({ block, onUpdate }: ButtonBlockProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Button Type</Label>
        <Select
          value={block.buttonVariant || "simple"}
          onValueChange={(value: ButtonVariant) => onUpdate({ buttonVariant: value })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="simple">Standard Button</SelectItem>
            <SelectItem value="form">Form Button</SelectItem>
            <SelectItem value="link">Text Link</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Text</Label>
        <Input
          value={block.content}
          onChange={(e) => onUpdate({ content: e.target.value })}
          placeholder="Button text"
        />
      </div>

      {block.buttonVariant !== "form" && (
        <div className="space-y-2">
          <Label>URL</Label>
          <Input
            value={block.url || ""}
            onChange={(e) => onUpdate({ url: e.target.value })}
            placeholder="https://..."
          />
        </div>
      )}

      <div className="space-y-2">
        <Label>Theme</Label>
        <Select
          value={block.theme || "light"}
          onValueChange={(value: ButtonTheme) => onUpdate({ theme: value })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="light">Light</SelectItem>
            <SelectItem value="dark">Dark</SelectItem>
            <SelectItem value="primary">Primary</SelectItem>
            <SelectItem value="secondary">Secondary</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {block.buttonVariant === "simple" && (
        <div className="space-y-2">
          <Label>Target</Label>
          <Select
            value={block.target || "self"}
            onValueChange={(value: ButtonTarget) => onUpdate({ target: value })}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="self">Same Window</SelectItem>
              <SelectItem value="new">New Window</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};
